import { useState, useEffect, useContext } from "react";
import { vdomain } from "commons/config";
import { langContext } from "commons/contexts";

import style from "./style.module.scss";
import Item from "./Item";

type textType = { [key: string]: { [key: string]: string } };

const descs: textType = {
    nl: {
        "Ben-1": "Adembenemend panoramisch uitzicht, uw eigen tennisbaan, privacy, veel ruimte en wat een tuin!",
        "Mar-42": "Machtig mooi boutique complex van slechts 24 ruime luxe villa’s, gelegen Te Marbella.",
        "Vil-1": "Een aan zee gelegen prachtige promotie van kwalitatieve appartementen met mooie tuinen inclusief eigen voet en fietspaden.",
        "Laz-1": "Adembenemend panoramisch uitzicht, uw eigen tennisbaan, privacy, veel ruimte en wat een tuin!",
    },
    fr: {
        "Ben-1": "Une vue panoramique à couper le souffle, votre propre court de tennis, intimité, beaucoup d'espace et quel jardin!",
        "Mar-42": "Beau complexe de charme de seulement 24 villas de luxe spacieuses, situé à Marbella.",
        "Vil-1": "Une belle promotion balnéaire d'appartements de qualité avec de beaux jardins dont des pistes cyclables et piétonnes privées.",
        "Laz-1": "Vue panoramique époustouflante, votre propre court de tennis, de l'intimité, beaucoup d'espace et quel jardin",
    }
}

const items = [ 
    "Ben-1",
    "Mar-42",
    "Vil-1",
    "Laz-1",
];

const text: textType = {
    nl: {
        text1: "EIGENDOMMEN",
        text2: "TE KOOP"
    },
    fr: {
        text1: "PROPRIÉTÉS",
        text2: "À VENDRE"
    }
}

function Properties() {

    const [itemImages, setItemImages] = useState([]);
    const [itemsData, setItemsData] = useState<{ [key: string]: any }>({});

    const { lang } = useContext(langContext);


    useEffect(() => {
        items.forEach(item => getProperty(item));
    }, []);


    function getProperty(refNo: string) {
        try {
            fetch(vdomain + "/int-search", { method: "POST", body: JSON.stringify({ ref: refNo }) }).then(response => {
                response.json().then((result) => {
                    const property: { [key: string]: any } = {};
                    property[refNo] = result[0][refNo];

                    setItemsData(oldData => ({ ...oldData, ...property }));
                });
            });
        } catch { }
    }

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.titlePart}>
                    <div>{text[lang]?.text1 || ""}</div>
                    <div>{text[lang]?.text2 || ""}</div>
                </div>

                <div className={style.propsContainer}>
                    {items.map((item, i) => <Item refNo={item} key={item} imagesState={{ itemImages, setItemImages }} data={{ ...(itemsData[item]), desc: (descs[lang] ? (descs[lang][item] || "") : "") }} />)}
                </div>
            </div>
        </div>
    );
}

export default Properties;